/**
 * @file Card showing one charge template's details, with a mark on a row its request's 400 named.
 * No failure path: a row without `error` shows no mark.
 */
import * as React from "react";
import Component from "../../AbstractComponent";
import ChargeTemplateDetailsReadonly from "./ChargeTemplateDetailsReadonly";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import {
	Card
} from '@material-ui/core';

export default class ChargeTemplateCard extends Component {
	public state = {
	};

  constructor(public props) {
    super(props);
	}

  public render() {
		const chargeTemplate: ChargeTemplateInterface = this.props.chargeTemplate;

    return (
			<Card 
				className="card no-padding" 
				style={{position: "relative"}}
			>
				{this.props.chargeTemplate?.error &&
					<span className="icon icon-ic-info red charge-template-card-error-mark" style={{position: "absolute", right: "12px", bottom: "12px"}}></span>
				}
				<div className="main-inner-wrapper" style={{padding: "10px 40px 10px 10px", marginBottom: "10px"}}>
					<ChargeTemplateDetailsReadonly {...this.props} chargeTemplate={chargeTemplate} />
				</div>
				<div style={{height: "1px"}}></div>
			</Card>
    );
  }
}
